import { call, takeLatest } from 'redux-saga/effects';
import { GlobalAction, GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';

export function* watchEinzelwerteChanged() {
  yield takeLatest(GlobalActions.EINZELWERTE_CHANGED, updateAppAndTarifiere);
}

export function* updateAppAndTarifiere(action: GlobalAction<unknown>) {
  const globalPut = GlobalPut.getInstance();
  yield call(globalPut.put, new GlobalActions().tarifiereShopSync(action));
}
